export const getIconClass = (icon?: string) => (icon ? 'icon-[' + icon + ']' : '')
